import React, { useState, useEffect } from 'react';
import devuelveReglamentoSanciones from './devuelveReglamentoSanciones';
import './piton.css';
import axios from 'axios';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
import Swal from "sweetalert2";
import socket from '../tools/socke';

const CreaSancion = ({ cadete, onClose }) => {
  const Usuario = ObtieneDatosCookies();
  const sanciones = devuelveReglamentoSanciones();
  const [selectedSancion, setSelectedSancion] = useState('');
  const [selectedInciso, setSelectedInciso] = useState('');
  const [opcionSeleccionada, setOpcionSeleccionada] = useState('');
  const [texto, setTexto] = useState('');
  const [elMinimo, setElMinimo] = useState(0);
  const [elMaximo, setElMaximo] = useState(0);
  const [fechaFaltaCometida, setFechaCometida] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // Nuevo estado

  const cadeteDni = cadete?.cadeteDni;

  const cadetePromocion = cadete?.Promocions[0]?.id||cadete?.Promocions?.id

const creaSancionForm = async (e) => {
  e.preventDefault();

  if (!selectedSancion || !selectedInciso || !opcionSeleccionada || !fechaFaltaCometida || !texto) {
    Swal.fire({
      title: "Error",
      text: "Todos los campos deben estar completos.",
      icon: "error",
      confirmButtonText: "OK",
    });
    return;
  }

  // 🔥 CONFIRM ANTES DE ENVIAR
  const confirm = await Swal.fire({
    title: "¿Confirmar sanción?",
    html: `
      <p><b>Cadete DNI:</b> ${cadeteDni}</p>
      <p><b>Artículo:</b> ${selectedSancion}</p>
      <p><b>Inciso:</b> ${selectedInciso}</p>
      <p><b>Cantidad:</b> ${opcionSeleccionada >= 1 ?opcionSeleccionada+ "Amonestacion" : "Apercibimiento"}</p>
      <p><b>Descripción de la falta:</b> ${texto}</p>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, generar",
    cancelButtonText: "Cancelar",
    reverseButtons: true,
  });

  if (!confirm.isConfirmed) return;

  setIsSubmitting(true);

  const datos = {
    cadeteDni,
    cadeteSede: cadete?.cadeteSede,
    fechaFaltaCometida,
    articulo: selectedSancion,
    inciso: selectedInciso,
    cantidad: opcionSeleccionada,
    estado: 'Activa',
    promocionId: cadetePromocion,
    descripcionFalta: texto,
    tipo: opcionSeleccionada >= 1 ? "Amonestacion" : "Apercibimiento",
    usuarioSanciona: `${Usuario.nombre} ${Usuario.apellido}`,
    idUsuarioSanciona: Usuario.id
  };

  const username = process.env.REACT_APP_KEY;
  const password = process.env.REACT_APP_PASS;
  const token = btoa(`${username}:${password}`);

  try {
    const response = await axios.post(
      `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/creaSancion/`,
      datos,
      {
        headers: { Authorization: `Basic ${token}` },
      }
    );

    if (response.data.success) {
      Swal.fire({
        title: "Sanción generada con éxito",
        text: `Se generó una sanción para el cadete ${cadete.cadeteDni}`,
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        socket.emit("sancionEvent", "");
        onClose();
      });
    } else {
      Swal.fire({
        title: response.data.message,
        text: "Compruebe los datos, algo pudo salir mal.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }

  } catch (error) {
    Swal.fire({
      title: "Error",
      text: "Fallo la generación, compruebe si el cadete existe.",
      icon: "error",
      confirmButtonText: "OK",
    });
//     console.log('Error al enviar los datos:', error);
  } finally {
    setIsSubmitting(false);
  }
};

  const handleSancionChange = (e) => {
    setSelectedSancion(e.target.value);
    setSelectedInciso('');
  };

  const selectedSancionData = sanciones.find((s) => s.id === selectedSancion) || {};
  const incisos = selectedSancionData.Incisos || [];
  const selectedIncisoData = incisos.find((inciso) => Object.values(inciso)[0] === selectedInciso.split(' - ')[1]?.trim()) || null;

  useEffect(() => {
    if (selectedIncisoData) {
      setElMinimo(Number(selectedIncisoData.minimo) || 0);
      setElMaximo(Number(selectedIncisoData.maximo) || 0);
    } else {
      setElMinimo(0);
      setElMaximo(0);
    }
  }, [selectedIncisoData]);

  const rango = (min, max) => Array.from({ length: max - min + 1 }, (_, i) => min + i);
  const resultadoRango = rango(elMinimo, elMaximo);

  return (
    <>
      <h3 className='tituloSancion'>Cadete a sancionar Dni: {cadeteDni || 'No disponible'} </h3>
      <form className='formLuis' onSubmit={creaSancionForm}>
        <label>Sanción:</label>
        <select className={`form-control ${selectedSancion ? "is-valid" : "is-invalid"}`} onChange={handleSancionChange} value={selectedSancion}>
          <option value="">-- Selecciona --</option>
          {sanciones.map((sancion) => (
            <option key={sancion.id} value={sancion.id}>{sancion.id} - {sancion.descripcion}</option>
          ))}
        </select>

        <label>Inciso:</label>
        <select className={`form-control ${selectedInciso ? "is-valid" : "is-invalid"}`} value={selectedInciso} onChange={(e) => setSelectedInciso(e.target.value)}>
          <option value="">Selecciona...</option>
          {incisos.map((inciso, index) => {
            const clave = Object.keys(inciso)[0];
            const valor = Object.values(inciso)[0];
            return (
              <option key={index} value={`${clave} - ${valor}`}>{clave} - {valor.length > 100 ? valor.substring(0, 100) + "..." : valor}</option>
            );
          })}
        </select>

        <textarea className="textArea" value={selectedInciso ? selectedInciso.split(' - ')[1] : ''} disabled rows="3" />

        <label>Cantidad:</label>
        <select className={`form-control ${opcionSeleccionada ? "is-valid" : "is-invalid"}`} value={opcionSeleccionada} onChange={(e) => setOpcionSeleccionada(e.target.value)}>
          <option value="">Selecciona...</option>
          {resultadoRango.map((valor, index) => (
            <option key={index} value={valor}>{valor === 0.5 ? 'Apercibimiento' : valor === 16 ? 'Baja' : valor}</option>
          ))}
        </select>

        <label>Fecha de la comisión de la Falta</label>
        <input type="date" className={`form-control ${fechaFaltaCometida ? "is-valid" : "is-invalid"}`} onChange={(e) => setFechaCometida(e.target.value)} value={fechaFaltaCometida} max={new Date().toISOString().split("T")[0]} />

        <label>Descripción de la falta:</label>
        <textarea className={`form-control ${texto ? "is-valid" : "is-invalid"}`} maxLength={512} value={texto} onChange={(e) => setTexto(e.target.value)} />

        <button
          type="submit"
          className='botonLuis'
          disabled={
            !selectedSancion ||
            !selectedInciso ||
            !opcionSeleccionada ||
            !fechaFaltaCometida ||
            !texto ||
            isSubmitting // Se desactiva mientras espera
          }
        >
          {isSubmitting ? 'Enviando...' : 'Sancionar'}
        </button>
      </form>
    </>
  );
};

export default CreaSancion;
